import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox,TextField } from '@mui/material';
import { AclCondition } from 'common/types/Entities';
import { editDrawerTextFieldStyles } from 'common/utils/StyleHelpers';

interface AclResourcesConditionsMultiSelectProps {
    availableConditions: AclCondition[];
    selectedConditions: string[];
    onChange: (selected: string[]) => void;
    nameInConflict?: boolean;
}

export function AclResourcesConditionsMultiSelect({
    availableConditions,
    selectedConditions,
    onChange,
    nameInConflict
}: Readonly<AclResourcesConditionsMultiSelectProps>) {
    return (
        <Autocomplete
            value={availableConditions.filter(cond => selectedConditions.includes(cond.key))}
            onChange={(_, newValue) => onChange(newValue.map(cond => cond.key))}
            multiple
            options={availableConditions}
            disableCloseOnSelect
            getOptionLabel={opt => opt.name}
            isOptionEqualToValue={(option, val) => option.key === val.key}
            noOptionsText={'No ACL Conditions available'}
            renderOption={(optionProps, option, { selected }) => {
                const { key, ...otherProps } = optionProps;
                return (
                    <li key={key} {...otherProps}>
                        <Checkbox
                            icon={<CheckBoxOutlineBlank fontSize={'small'} />}
                            checkedIcon={<CheckBox fontSize={'small'} />}
                            style={{ marginRight: '8px' }}
                            checked={selected}
                        />
                        {option.name}
                    </li>
                );
            }}
            renderInput={params => (
                <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    sx={editDrawerTextFieldStyles(nameInConflict)}
                    label='ACL Conditions'
                    placeholder={selectedConditions.length === 0 ? 'Select ACL Conditions' : ''}
                    InputProps={{
                        ...params.InputProps,
                        disableUnderline: nameInConflict
                    }}
                />
            )}
        />
    );
}
